import {Component, OnInit, OnDestroy} from '@angular/core';
import {ManageService} from '../../../services/manage.service';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Observable, Subject, of} from 'rxjs';
import {catchError, debounceTime, map, switchMap, tap, retry, takeUntil} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {CSPTenantUser} from '../../../models/csp.model';
import {ApiResponse} from '../../../models/api-response.model';
import {CommonService} from '../../../services/common.service';
import {HttpClient} from '@angular/common/http';
import {CheckOutService} from '../../../services/checkout.service';


@Component({
  selector: 'configure-end-user',
  templateUrl: './configure-end-user.component.html',
  styleUrls: ['./configure-end-user.component.css'],
})
export class ConfigureEndUserComponent implements OnInit, OnDestroy {

  addUserFormaddUserForm: FormGroup;
  searchUserForm: FormGroup;
  currentTenantUsers: CSPTenantUser[] = [];
  searchedTenantUsers: CSPTenantUser[] = [];
  tenantId: string;
  tab: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  loadContent = true;
  contactUsForm: FormGroup;
  addUserForm: FormGroup;
  //#00abc2
  color: string;
  files: File[] = [];
  uploadFile: File;
  access: boolean = false;
  hidePricing: boolean = false;
  notificationEmail: string;
  EUDisplayText: string;
  showReassign = false;
  isManuallyInvite: boolean = true;

  //regex
  email_regex = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$');

  phone_regex = new RegExp('^[0-9]+$');

  constructor(private manageService: ManageService,
              private route: ActivatedRoute,
              private checkOutService: CheckOutService,
              private http: HttpClient,
              private commonService: CommonService) {
    this.searchUserForm = new FormGroup({
      userName: new FormControl('')
    });
    this.addUserForm = new FormGroup({
      email: new FormControl('', this.commonService.emailValidatorRegex())
    });

    this.contactUsForm = new FormGroup({
      contactEmail: new FormControl('', this.commonService.emailValidatorRegex()),
      contactPhone: new FormControl('', [Validators.pattern('^[0-9]+$')]),

      companyName: new FormControl('',),
      address1: new FormControl('',),
      address2: new FormControl('',),
      suburb: new FormControl(''),
      state: new FormControl('',),
      postcode: new FormControl('', [Validators.pattern('^[0-9]{4}$')]),

    });
    //this.notificationEmailControl = new FormControl('');
  }

  ngOnInit() {

    this.loadContent = false;

    this.manageService.getTenantBranding(this.tenantId).pipe(
      switchMap((res: any) => {
        //"http://localhost:60947/images/logo-invert.png"
        if (res.imageUrl) {
          return this.downloadImage(res.imageUrl).pipe(
            map((file: File) => {
              return {
                color: res.colorCode,
                access: res.purchaseAccess,
                hidePricing: res.hidePricing,
                email: res.email,

                contactEmail: res.contactEmail,
                contactPhone: res.contactPhone,
                address1: res.address1,
                address2: res.address2,
                companyName: res.companyName,
                suburb: res.suburb,
                postcode: res.postCode,
                state: res.state,

                //address3: res.address3,
                file: file
              };
            })
          );
        } else {
          return of({
            color: res.colorCode,
            access: res.purchaseAccess,
            hidePricing: res.hidePricing,
            email: res.email,

            contactEmail: res.contactEmail,
            contactPhone: res.contactPhone,
            address1: res.address1,
            address2: res.address2,
            companyName: res.companyName,
            suburb: res.suburb,
            postcode: res.postCode,
            state: res.state,

            //address3: res.address3,
            file: null
          });
        }
      })
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((payload) => {
      //"#00abc2"
      this.color = payload.color ? payload.color : '#00abc2';

      this.access = payload.access;

      this.notificationEmail = payload.email;

      this.hidePricing = payload.hidePricing;

      this.contactUsForm.get('contactEmail').setValue(payload.contactEmail);

      this.contactUsForm.get('contactPhone').setValue(payload.contactPhone);

      this.contactUsForm.get('companyName').setValue(payload.companyName);

      this.contactUsForm.get('address1').setValue(payload.address1);

      this.contactUsForm.get('address2').setValue(payload.address2);

      this.contactUsForm.get('suburb').setValue(payload.suburb);

      this.contactUsForm.get('state').setValue(payload.state);

      this.contactUsForm.get('postcode').setValue(payload.postcode);

      if (payload.file) {

        this.uploadFile = payload.file;
        this.files.push(this.uploadFile);

      }

      this.loadContent = true;
    }, () => {
      this.loadContent = true;
    });

    this.manageService.currentTenantEndUsers.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => this.currentTenantUsers = res);

    this.searchUserForm.get('userName').valueChanges.pipe(
      debounceTime(500),
      tap(() => this.loadContent = false),
      switchMap(value => value && value.length > 2 ? this.manageService.searchTenantUsers(this.tenantId, value) : of([])
      )
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res.status == false) {
        this.loadContent = true;
        debugger;
        this.commonService.implementToast(res.responseMessage , 'Error');
      } else {
        this.searchedTenantUsers = res;
        const userGuidList: string[] = this.currentTenantUsers.map(m => m.userGuid);
        this.searchedTenantUsers = res.filter(m => !userGuidList.includes(m.id));
        this.loadContent = true;
      }
    });


    // this.notificationEmailControl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
    //     const regex = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}(\\s|,)$");
    //     if (regex.test(value)) {
    //         value = replace(value, ',', ' ');
    //         this.notificationEmailArray.push(value.trim())
    //         this.notificationEmailControl.setValue('');
    //         //console.log(this.notificationEmailArray);
    //     }
    // });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  addEndUser(user: any, index: number) {
    let addedUser: CSPTenantUser = <CSPTenantUser>{};
    let usersArray: CSPTenantUser[] = [];
    addedUser.userGuid = user.id;
    addedUser.isSelected = true;
    addedUser.firstName = user.givenName;
    addedUser.lastName = user.surname;
    addedUser.userPrincipalName = user.userPrincipalName;
    addedUser.displayName = user.displayName;
    usersArray.push(addedUser);
    this.manageService.CreateTenantUsers(this.tenantId, usersArray).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: ApiResponse) => {
      if (res.status) {
        this.commonService.implementToast('End users have been updated successfully', 'Success');
        this.manageService.monitorCurrentEndUserUpdateStatus('Success');
        this.searchedTenantUsers.splice(index, 1);
      } else {
        this.commonService.implementToast('Failed to update end users, please try again', 'Error');
      }
    });
  }

  // changeComplete(event: any) {
  //   console.log();
  // }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  onSelect(event) {

    //over file size limit
    if (event.rejectedFiles.length > 0) {
      this.commonService.implementToast('max file size is 1MB', 'Error');

    } else {

      this.files = [];

      const reader = new FileReader();

      reader.onload = () => {

        const img = document.createElement('img') as HTMLImageElement;

        img.onload = () => {

          const canvas = this.resizeImage(img, img.naturalWidth, img.naturalHeight);

          canvas.toBlob(
            (blob) => {
              //const fileExtension = event.addedFiles[0].name
              this.uploadFile = new File([blob], `${this.tenantId}.png`, {
                type: 'image/png',
              });
              this.files.push(this.uploadFile);
            },
            'image/png',
            1);

        };

        img.src = reader.result as string;
      };

      reader.readAsDataURL(event.addedFiles[0]);
    }


    // const reader = new FileReader();
    // reader.onload = () => {
    //     const img = document.createElement("img") as HTMLImageElement;
    //     img.onload = () => {
    //         //console.log(img.naturalWidth, img.naturalHeight);
    //         if (img.naturalWidth <= 150 && img.naturalHeight <= 40) {
    //             this.files = [];
    //             this.files.push(...event.addedFiles);
    //         } else {
    //             this.commonService.implementToast("max width is 150px, max height is 40px", "Error");
    //         }
    //     }
    //     img.src = reader.result as string;
    // };
    // reader.readAsDataURL(event.addedFiles[0]);

  }

  onRemove(event) {
    this.uploadFile = null;
    this.files.splice(this.files.indexOf(event), 1);
  }

  updateTenantBranding() {


    //nofitication email validate


    if(this.contactUsForm.invalid)
    {
      this.commonService.implementToast('Contact Us Form has invalid fields', 'Error');

      return;
    }

    if (this.notificationEmail) {

      if (!this.email_regex.test(this.notificationEmail)) {

        this.commonService.implementToast('Notification Email is not valid', 'Error');

        return;
      }

    }


    //contact us validation


    //contact email validation
    // if (this.contactEmail) {
    //
    //   if (!this.email_regex.test(this.contactEmail)) {
    //
    //     this.commonService.implementToast('Contact Email is not valid', 'Error');
    //
    //     return;
    //
    //   }
    // }

    // //contact phone number validation
    // if (this.contactPhone) {
    //
    //   if (!this.phone_regex.test(this.contactPhone)) {
    //
    //     this.commonService.implementToast('Contact Phone Number is not valid', 'Error');
    //
    //     return;
    //
    //   }
    // }


    const formData = new FormData();

    formData.append('tenantBranding', JSON.stringify({
      tenantId: this.tenantId,
      colorCode: this.color,
      purchaseAccess: this.access,
      hidePricing: this.hidePricing,
      //notificationEmail: this.notificationEmailArray.length > 0 ? this.notificationEmailArray.join(",") : ''
      notificationEmail: this.notificationEmail,

      companyName: this.contactUsForm.get('companyName').value,
      contactEmail: this.contactUsForm.get('contactEmail').value,
      contactPhone: this.contactUsForm.get('contactPhone').value,
      address1: this.contactUsForm.get('address1').value,
      address2: this.contactUsForm.get('address2').value,
      state: this.contactUsForm.get('state').value,
      suburb: this.contactUsForm.get('suburb').value,
      postcode: this.contactUsForm.get('postcode').value
      //address3:this.address3
    }));

    if (this.uploadFile) {
      formData.append('file', this.uploadFile, this.uploadFile.name);
    }

    this.loadContent = false;
    this.manageService.updateTenantBranding(formData).subscribe((res: ApiResponse) => {

      if (res.status) {
        this.loadContent = true;
        this.commonService.implementToast('Site Branding Updated Successfully', 'Success');
      } else {
        this.loadContent = true;
        this.commonService.implementToast('Failed to Update Tenant Branding', 'Error');
      }
    });

  }

  downloadImage(url: string): Observable<File | null> {

    const fileName = url.substring(url.lastIndexOf('/') + 1);

    const fileExtension = url.substring(url.lastIndexOf('.') + 1);

    const fileType = `image/${fileExtension}`;

    return this.http.get(`${url}?v=${(+new Date).toString(36)}`, {
      responseType: 'blob'
    }).pipe(
      map((data: Blob) => {
        const image = new File([data], fileName, {
          type: fileType,
        });
        return image;
      }),
      retry(3),
      catchError(() => {
        this.commonService.implementToast('failed to download company logo', 'Error');
        return of(null);
      })
    );
  }

  closePage() {
    this.manageService.monitorConfigureEndUserStatus({status: false, tenantId: ''});
  }

  deleteImage() {

    this.manageService.deleteTenantLogo(this.tenantId).subscribe((res: ApiResponse) => {
        if (res.status) {

          this.files = [];

          this.uploadFile = null;

          this.commonService.implementToast('Tenant Logo has been deleted Successfully', 'Success');

        } else {
          this.commonService.implementToast('Failed to Delete Tenant Logo', 'Error');
        }
      },
      () => {
        this.commonService.implementToast('Failed to Delete Tenant Logo', 'Error');
      });
    ;

  }

  resizeImage(img: any, width: number, height: number) {

    const maxWidth = 400;

    const maxHeight = 100;

    let ratio;

    const canvas = document.createElement('canvas') as HTMLCanvasElement;

    var ctx = canvas.getContext('2d');

    if (width > maxWidth) {

      ratio = maxWidth / width;

      width = width * ratio;

      height = height * ratio;

    }

    // Check if current height is larger than max
    if (height > maxHeight) {

      ratio = maxHeight / height;

      width = width * ratio;

      height = height * ratio;

    }

    canvas.width = width;

    canvas.height = height;

    ctx.drawImage(img, 0, 0, width, height);

    return canvas;

  }

  toggleManuallyInvite() {
    this.isManuallyInvite = !this.isManuallyInvite;
  }

  addUserManually() {

    if (this.addUserForm.valid) {

      // let [prefiex, domain] = split(this.addUserForm.controls['email'].value, '@');

      this.loadContent = false;

      this.manageService.AssignTenantUser(this.tenantId, this.addUserForm.controls['email'].value)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: ApiResponse) => {
          if (res.status) {
            this.addUserForm.controls['email'].setValue('');
            this.loadContent = true;
            this.EUDisplayText = 'End user have been added successfully'
            this.manageService.monitorCurrentEndUserUpdateStatus('Success');
          } else {
            this.loadContent = true;
            this.EUDisplayText = res.responseMessage
            this.showReassign = true;
          }
        });
    } else {
      if (this.addUserForm.controls['email'].errors.required) {

        this.commonService.implementToast('email address is required', 'Error');

      } else if (this.addUserForm.controls['email'].errors.pattern) {

        this.commonService.implementToast('email address is valid', 'Error');
      }
    }

  }

  reassignEU() {
    if (this.addUserForm.valid) {

      this.loadContent = false;

      this.manageService.ReAssignTenantUser(this.tenantId, this.addUserForm.controls['email'].value)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: ApiResponse) => {
          if (res.status) {
            this.addUserForm.controls['email'].setValue('');
            this.loadContent = true;
            this.EUDisplayText = 'End user have been added successfully'
            this.manageService.monitorCurrentEndUserUpdateStatus('Success');
            this.showReassign = false;
          } else {
            this.loadContent = true;
            this.EUDisplayText = res.responseMessage
            this.showReassign = true;
          }
        });
    } else {
      if (this.addUserForm.controls['email'].errors.required) {

        this.commonService.implementToast('email address is required', 'Error');

      } else if (this.addUserForm.controls['email'].errors.pattern) {

        this.commonService.implementToast('email address is valid', 'Error');
      }
    }
  }

  donotReassignEU() {
    this.addUserForm.controls['email'].setValue('');
    this.EUDisplayText = '';
    this.showReassign = false;
  }

  // removeNotificationEmail(index: number) {
  //     this.notificationEmailArray.splice(index, 1);
  // }
}
